export default __webpack_public_path__ + "static/media/sync.1c26edb7.webp";